import { ReactComponent as GeneralUnread } from "../img/notifications/general_unread.svg"
import { ReactComponent as AnnouncementUnread } from "../img/notifications/announcement_unread.svg"
import { ReactComponent as AlertsUnread } from "../img/notifications/alerts_unread.svg"
import { ReactComponent as AccountActivityUnread } from "../img/notifications/accountActivity_unread.svg"
import { ReactComponent as UpdatesUnread } from "../img/notifications/updates_unread.svg"
import { ReactComponent as GeneralRead } from "../img/notifications/general_read.svg"
import { ReactComponent as AnnouncementRead } from "../img/notifications/announcement_read.svg"
import { ReactComponent as AlertsRead } from "../img/notifications/alerts_read.svg"
import { ReactComponent as AccountActivityRead } from "../img/notifications/accountActivity_read.svg"
import { ReactComponent as UpdatesRead } from "../img/notifications/updates_read.svg"

const notificationUnreadIcons = {
1: GeneralUnread,
2: AnnouncementUnread,
3: AlertsUnread,
4: AccountActivityUnread,
5: UpdatesUnread
};

const notificationreadIcons = {
1: GeneralRead,
2: AnnouncementRead,
3: AlertsRead,
4: AccountActivityRead,
5: UpdatesRead
};

export const getNotificationIcons = (hasRead,mainCategoryId) => {
    return hasRead ? notificationreadIcons[mainCategoryId] : notificationUnreadIcons[mainCategoryId]        
}